import Employee from "./employee/employee_dashboard.store";
import Attendance from "./attendance/attendance_dasboard.store";

export default {
  modules: { Employee, Attendance },
};
